import { TOG_CsrDay7 } from '@/rtk-query.gql';

import { RecipSummaryRow, TransformResult, ValidRow } from './types';

export const TransformDataToRecipSummary = (
  rowData: TOG_CsrDay7[],
): TransformResult => {
  const validRows = rowData.filter(
    (row): row is ValidRow =>
      row.embryoToBe === 'Implanted' &&
      row.implantType === 'Purchased Pregnancy' &&
      typeof row.recipFrame === 'number' &&
      typeof row.breed === 'string' &&
      typeof row.bullBreed === 'string' &&
      typeof row.st === 'string',
  );

  const breedGroups = new Map<string, ValidRow[]>();
  validRows.forEach((row) => {
    const key = `${row.breed}_${row.bullBreed}_${row.st}`;
    const existing = breedGroups.get(key) || [];
    existing.push(row);
    breedGroups.set(key, existing);
  });

  const summaryRows: RecipSummaryRow[] = [];
  breedGroups.forEach((rows) => {
    const recipFrameGroups = new Map<number, typeof rows>();
    rows.forEach((row) => {
      const frame = row.recipFrame;
      const existing = recipFrameGroups.get(frame) || [];
      existing.push(row);
      recipFrameGroups.set(frame, existing);
    });

    recipFrameGroups.forEach((frameRows, frame) => {
      const firstRow = frameRows[0];
      summaryRows.push({
        recipFrame: String(frame),
        breed: firstRow.breed,
        bullBreed: firstRow.bullBreed,
        st: firstRow.st,
        count: frameRows.length,
      });
    });
  });

  summaryRows.sort((a, b) => {
    const keyA = `${a.breed}_${a.bullBreed}_${a.st}_${a.recipFrame}`;
    const keyB = `${b.breed}_${b.bullBreed}_${b.st}_${b.recipFrame}`;
    return keyA.localeCompare(keyB);
  });

  const total = summaryRows.reduce((sum, row) => sum + row.count, 0);

  return { summaryRows, total };
};
